//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const CacheQuery: any = {
    GetFilterCacheManagement: Backofficebff + '/v1/managecache/list-cachemanagement',

    GetListEcommerceTeam: Backofficebff + '/managecache/list-ecommerceteam',
    GetUSerClaims: Backofficebff + '/managecache/getuserclaims',
    GetRedisData: Backofficebff + '/managecache/redis-data',
    GetDefaultDatabase: Backofficebff + '/managecache/get-default-database',
};
